export default __webpack_public_path__ + "static/media/11.14.99d93ba4.jpg";